<template>
  <div id="sider">
    <div class="sider-wrap">
      <!-- 老师端侧边栏 -->
      <el-menu :default-active="siderActive" class="el-menu-vertical" v-if="menu === '1'">
        <el-menu-item index="home-page" @click="jumpPage('HomePage')">
          <span slot="title">Home Page</span>
        </el-menu-item>
        <el-menu-item index="schedule" @click="jumpPage('Schedule')">
          <span slot="title">Schedule Management</span>
        </el-menu-item>
        <el-menu-item index="study-report" v-if="showReport" @click="jumpPage('StudyReport')">
          <span slot="title">Student study report</span>
        </el-menu-item>
        <el-menu-item index="timetable" @click="jumpPage('Timetable')">
          <span slot="title">Timetable</span>
        </el-menu-item>
        <el-menu-item index="pre-booked" @click="jumpPage('PreBooked')" v-if="isShowPreBook">
          <span slot="title">Pre-booked Undone</span>
          <i class="red-dot" v-if="showVipApplyDot"></i>
        </el-menu-item>
        <el-menu-item index="training-material" @click="jumpPage('TrainingMaterial')">
          <span slot="title">Training Material</span>
        </el-menu-item>
        <el-menu-item index="profile" @click="jumpPage('Profile')">
          <span slot="title">My Profile</span>
        </el-menu-item>
        <el-menu-item index="policy" @click="jumpPage('Policy')">
          <span slot="title">Policy&amp;Contract</span>
        </el-menu-item>
        <el-menu-item index="suggestions" @click="jumpPage('Suggestions')">
          <span slot="title">Suggestions</span>
        </el-menu-item>
        <el-menu-item index="message" @click="openLink()">
          <span slot="title">Message</span>
          <img class="red-spot" v-if="showSpot" src="@/assets/img/alert.png" alt="" />
        </el-menu-item>
        <el-menu-item index="leave" @click="jumpPage('Leave')">
          <span slot="title">Submit a Leave</span>
        </el-menu-item>
        <el-menu-item index="ding-talk-binding" @click="jumpPage('DingTalkBinding')">
          <span slot="title">DingTalk binding</span>
        </el-menu-item>
      </el-menu>

      <!-- 引导页侧边栏 -->
      <el-menu v-if="menu === '2'" :default-active="siderActive" class="el-menu-vertical">
        <el-menu-item index="novice-guide" @click="jumpPage('NoviceGuide')">
          <span slot="title">Novice Guide</span>
        </el-menu-item>
      </el-menu>

      <!-- 代理端侧边栏 -->
      <el-menu v-if="menu === '3'" :default-active="siderActive" class="el-menu-vertical">
        <el-menu-item v-for="item in agtList" :key="item.index" :index="item.index" @click="jumpPage(item.page)">
          <span slot="title">{{ item.title }}</span>
        </el-menu-item>
      </el-menu>

      <!-- 公告栏 -->
      <bulletion-board v-if="menu === '3'"></bulletion-board>

      <!-- 新人完善资料 -->
      <el-menu v-if="menu === '4'" :default-active="siderActive" class="el-menu-vertical">
        <el-menu-item index="editing-info" @click="jumpPage('EditingInfo')">
          <span slot="title">More Information</span>
        </el-menu-item>
        <el-menu-item index="training-material-new" @click="jumpPage('TrainingMaterialNew')">
          <span slot="title">Training Materials</span>
        </el-menu-item>
        <el-menu-item index="agreement-new" @click="jumpPage('Agreement')">
          <span slot="title">Agreement</span>
        </el-menu-item>
      </el-menu>
      <!-- 合同签名页 -->
      <el-menu v-if="menu === '5'" :default-active="siderActive" class="el-menu-vertical">
        <el-menu-item index="beginner-guide" @click="jumpPage('BeginnerGuide')">
          <span slot="title">Beginner's Guide</span>
        </el-menu-item>
      </el-menu>

      <div class="app-sider" v-if="menu === '1'">
        <div class="app-title">App Download</div>
        <div class="app-img">
          <img src="@/assets/img/tea_app_ios.png" alt="" />
          <div class="text">IOS</div>
        </div>
        <div class="app-img">
          <img src="@/assets/img/tea_app_android.png" alt="" />
          <div class="text">Android</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import './index.less';
import axios from 'axios';
import qs from 'qs';
import {
  getTeacherInfo,
  getUserName,
  getUserId,
  getUserType
} from '@/utils/teacherAuth';
export default {
  watch: {
    $route(to, from) {
      if (this.$route.meta.parent) {
        this.menu = this.$route.meta.menu;
        this.siderActive = this.$route.meta.parent;
      } else {
        this.menu = to.meta.menu;
        this.siderActive = to.meta.parent;
      }
    }
  },
  created() {
    if (getTeacherInfo()) {
      let teacherObj = JSON.parse(getTeacherInfo());
      if (teacherObj.modelId == 8) {
        this.isShowPreBook = false;
      }
      if (teacherObj.viewAssessClass === 1) {
        this.showReport = true;
      }
    }
    if (getUserType() === '1') {
      this.isTeacher = true;
      //判断用户角色是否为老师
    }
    this.$bus.$on('getUnReadNum', () => {
      this.getUnReadNum();
    });
    this.$bus.$on('refreshVipApplyDot', () => {
      this.getVipApplyPendingCount();
    });
    this.$bus.$on('refreshPreBookedDot', () => {
      this.getPreBookedCount();
    });
    this.getUnReadNum();
    this.getVipApplyPendingCount();
    this.getPreBookedCount();
  },
  beforeDestroy() {
    this.$bus.$off('getUnReadNum');
    this.$bus.$off('refreshVipApplyDot');
    this.$bus.$off('refreshPreBookedDot');
  },
  data() {
    return {
      menu: this.$route.meta.menu,
      siderActive: this.$route.meta.parent,
      isShowPreBook: true,
      showReport: false,
      isTeacher: false,
      showSpot: false,
      unReadNum: 0,
      vipApplyPendingCount: 0,
      preBookedCount: 0,
      agtList: [
        { index: 'payroll', page: 'AgtPayroll', title: 'Payroll' },
        {
          index: 'scheduled-classes',
          page: 'ScheduledClasses',
          title: 'Scheduled Classes'
        },
        {
          index: 'student-feedback',
          page: 'StudentFeedback',
          title: 'Student feedback'
        },
        {
          index: 'class-statistics-page',
          page: 'ClassStatisticsPage',
          title: 'Class Statistics page'
        },
        {
          index: 'statistics-page',
          page: 'StatisticsPage',
          title: 'Statistics page'
        },
        {
          index: 'change-password',
          page: 'ChangePassword',
          title: 'Change Password'
        },
        { index: 'agt-policy', page: 'AgtPolicy', title: 'Policy & Contract' },
        { index: 'instructions', page: 'Instructions', title: 'Instructions' },
        {
          index: 'resignation-application',
          page: 'ResignationApplication',
          title: 'Resignation Application'
        }
      ]
    };
  },
  computed: {
    showVipApplyDot() {
      return this.vipApplyPendingCount > 0 || this.preBookedCount > 0;
    }
  },
  methods: {
    getUnReadNum() {
      let id = getUserId();
      let api = '/pointServer/pointToPoint/getPointUnReadNum';
      let url = '';
      if (process.env.NODE_ENV === 'development') {
        url = `https://test.usongshu.com${api}`;
      } else {
        url = `${process.env.IM}${api}`;
      }
      axios
        .post(url, {
          userId: id,
          platformType: 0
        })
        .then(res => {
          if (res.data.resultCode == 0) {
            this.unReadNum = res.data.resultData.unReadMesNum;
            if (this.unReadNum > 0) {
              this.showSpot = true;
            } else {
              this.showSpot = false;
            }
          }
        })
        .catch(e => {
          console.log(e);
        });
    },
    jumpPage(name) {
      this.$router.push({ name });
      this.$bus.$emit('getMessage');
      this.getUnReadNum();
    },
    openLink() {
      let username = getUserName();
      let id = getUserId();
      let url = `${process.env.MESSAGE_LINK}?fromUserId=${id}&fromUserNickName=${username}&fromUserType=2&platformType=0`;
      window.open(url, '_blank');
      setTimeout(() => {
        this.getUnReadNum();
      }, 3000);
    },
    async getVipApplyPendingCount() {
      try {
        const res = await this.$api.teaApplyList({ pageSize: 1, currPage: 1 });
        this.vipApplyPendingCount = Number(res.data.totalCount || 0);
      } catch (e) {
        this.vipApplyPendingCount = 0;
      }
    },
    async getPreBookedCount() {
      try {
        const res = await this.$api.getprebookedList(1);
        this.preBookedCount = Number(res.data.totalCount || 0);
      } catch (e) {
        this.preBookedCount = 0;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/global-components/Sider/index.vue